import { useEffect, useMemo, useState } from "react";

import style from "../../../sass/components/popups/create-shipment-popup.module.scss";
import {
    B2B_PACKAGE_TYPE,
    C2C_PACKAGE_TYPE,
    DOCUMENTS_PACKAGE_TYPE,
    STANDARD_PACKAGE_TYPE,
    VISIT_OFFICE_DELIVERY_TYPE,
    deliverySpeeds,
    senderCities,
} from "../../../data/static-data";
import { packageTypes } from "../../../data/static-data";
import { paymentTypes } from "../../../data/static-data";
import { useSelector } from "react-redux";
import { selectUser } from "../../user/userSlice";
import { validators } from "../../../validators/validators";
import { useTranslation } from "react-i18next";
import { isB2BPackage } from "../../../helpers/packageTypesHelper/packageTypesHelper";
import SenderTownInput from "./SenderTownInput";
import SenderDistrictComponent from "./Inputs/SenderDistrictComponent";

const AdditionalData = ({ state, setState, errors, setErrors }) => {
    const { t, i18n } = useTranslation();
    
    const selectedCityHasExpressPickup = useMemo(() => {
        let city = senderCities.find(
            (c) => +c.value === +state["sender-city-code"]
        );
        if (city) {
            return city.hasExpressPickup;
        }
    }, [state["sender-city-code"]]);

    const selectedTownHasCourierDelivery = useMemo(() => {
        if (!state["sender-town-id"] || !state["sender-district-id"]) {
            return false;
        }
        return true
    }, [state["sender-district-id"]]);

    const deliveryType = useSelector(
        (state) => state.shipments.createShipmentPopup.deliveryType
    );
    const deliverySpeed = useSelector(
        (state) => state.shipments.createShipmentPopup.deliverySpeed
    );
    const packageType = useSelector(
        (state) => state.shipments.createShipmentPopup.packageType
    );
    const paymentType = useSelector(
        (state) => state.shipments.createShipmentPopup.paymentType
    );
    const initialSenderCityCode = useSelector(
        (state) => state.shipments.createShipmentPopup.senderCityCode
    );
    const initialSenderTownID = useSelector(
        (state) => state.shipments.createShipmentPopup.senderTownID
    );

    const user = useSelector(selectUser);

    const [senderTown, setSenderTown] = useState("");

    useEffect(() => {
        if (state["delivery-speed"]) {
            return;
        }
        setState((prev) => ({
            ...prev,
            "delivery-speed": deliverySpeeds.standard?.value ?? "",
        }));
    }, [setState, state]);

    useEffect(() => {
        if (state["package-type"]) {
            return;
        }

        if (user?.type === "individual") {
            setState((prev) => ({
                ...prev,
                "package-type": packageTypes[0]?.value ?? "",
            }));
            return;
        }

        setState((prev) => ({
            ...prev,
            "package-type": packageTypes[1]?.value ?? "",
        }));
    }, [setState, state, user, user?.type]);

    useEffect(() => {
        if (state["payment-type"]) {
            return;
        }
        setState((prev) => ({
            ...prev,
            "payment-type": paymentTypes[0]?.value ?? "",
        }));
    }, [setState, state]);

    const setDeliverySpeed = (e) => {
        setState((prev) => ({
            ...prev,
            "delivery-speed": e.target.value,
        }));
    };

    const setPackageType = (e) => {
        if (e.target.value === B2B_PACKAGE_TYPE) {
            setState((prev) => ({
                ...prev,
                "delivery-speed": deliverySpeeds[0]?.value ?? "",
                "B2B-order-type": "courier",
                "B2B-order-number": "",
            }));
        }
        setState((prev) => ({
            ...prev,
            "package-type": e.target.value,
        }));
    };

    const setPaymentType = (e) => {
        setState((prev) => ({
            ...prev,
            "payment-type": e.target.value,
        }));
    };

    const setDeliveryType = (e) => {
        setState((prev) => ({
            ...prev,
            "getting-package-type": e.target.value,
        }));
    };

    const setSenderCity = (e) => {
        setState((prev) => ({
            ...prev,
            "sender-city-code": e.target.value,
        }));
    };

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            "sender-town-id": senderTown,
        }));
    },[senderTown, setState])

    const setB2BOrderType = (e) => {
        setState((prev) => ({
            ...prev,
            "B2B-order-type": e.target.value,
        }));
    };

    const setDeclaredPrice = (e) => {
        if (!e.target.value) {
            setState((prev) => ({
                ...prev,
                "declared-price": "",
            }));
        }

        if (validators.ValidateNumber(e.target.value)) {
            return;
        }

        setState((prev) => ({
            ...prev,
            "declared-price": +e.target.value,
        }));
    };

    const setDeclaredPriceCurrency = (e) => {
        setState((prev) => ({
            ...prev,
            "declared-price-currency": e.target.value,
        }));
    };

    const setB2BOrderNumber = (e) => {
        if (!e.target.value) {
            setState((prev) => ({
                ...prev,
                "B2B-order-number": "",
            }));
        }

        if (validators.ValidateNumber(e.target.value)) {
            return;
        }

        setState((prev) => ({
            ...prev,
            "B2B-order-number": +e.target.value,
        }));
    };

    const setSenderAddress = (e) => {
        setState((prev) => ({
            ...prev,
            "sender-address": e.target.value,
        }));
    };

    useEffect(() => {
        if (deliveryType) {
            setState((prev) => ({
                ...prev,
                "getting-package-type": deliveryType,
            }));
        }
    }, [deliveryType, setState]);
    useEffect(() => {
        if (deliverySpeed) {
            setState((prev) => ({
                ...prev,
                "delivery-speed": deliverySpeed,
            }));
        }
    }, [deliverySpeed, setState]);
    useEffect(() => {
        if (packageType) {
            setState((prev) => ({
                ...prev,
                "package-type": packageType,
            }));
        }
    }, [packageType, setState]);
    useEffect(() => {
        if (paymentType) {
            setState((prev) => ({
                ...prev,
                "payment-type": paymentType,
            }));
        }
    }, [paymentType, setState]);
    useEffect(() => {
        if (initialSenderCityCode) {
            setState((prev) => ({
                ...prev,
                "sender-city-code": initialSenderCityCode,
            }));
        }
    }, [initialSenderCityCode, setState]);
    useEffect(() => {
        if(state["sender-town-id"]) return;

        let city = senderCities.find(
            (c) => +c.value === +initialSenderCityCode || c.value === +state["sender-city-code"]
        );
        let containsTown = city?.towns?.find(
            (t) => +t.value === +initialSenderTownID
        ); 

        if (containsTown) {
            setState((prev) => ({
                ...prev,
                "sender-town-id": initialSenderTownID,
            }));
        }

    }, [state, initialSenderCityCode, initialSenderTownID, setState]);

    return (
        <>
            <header className="text-2xl text-left text-emerald-600 mb-5">
                {t("shipments.create_shipment.additional_data.title")}
            </header>
            <main className="text-left flex flex-col gap-4">
                <div className="grid grid-cols-12">
                    <span className="col-span-12 text-gray-600">
                        {t(
                            "shipments.create_shipment.additional_data.package_type.name"
                        )}
                    </span>
                    <select
                        className={`${style.select} col-span-10`}
                        id="sender-city"
                        value={state["package-type"]}
                        onChange={setPackageType}
                    >
                        <option
                            defaultValue={
                                state["package-type"] === DOCUMENTS_PACKAGE_TYPE
                            }
                            value={DOCUMENTS_PACKAGE_TYPE}
                        >
                            {t(
                                "shipments.create_shipment.additional_data.package_type.values.documents"
                            )}
                        </option>
                        {user && user["user-type"] === "individual" && (
                            <>
                                <option
                                    defaultValue={
                                        state["package-type"] ===
                                        STANDARD_PACKAGE_TYPE
                                    }
                                    value={STANDARD_PACKAGE_TYPE}
                                >
                                    {t(
                                        "shipments.create_shipment.additional_data.package_type.values.standard"
                                    )}
                                </option>
                                <option
                                    defaultValue={
                                        state["package-type"] ===
                                        C2C_PACKAGE_TYPE
                                    }
                                    value={C2C_PACKAGE_TYPE}
                                >
                                    {t(
                                        "shipments.create_shipment.additional_data.package_type.values.C2C"
                                    )}
                                </option>
                            </>
                        )}
                        {user && user["user-type"] === "legal" && (
                            <option
                                defaultValue={
                                    state["package-type"] === B2B_PACKAGE_TYPE
                                }
                                value={B2B_PACKAGE_TYPE}
                            >
                                {t(
                                    "shipments.create_shipment.additional_data.package_type.values.B2B"
                                )}
                            </option>
                        )}
                    </select>
                </div>
                <div className="grid grid-cols-12">
                    <span className="col-span-12 text-gray-600">
                        {t(
                            "shipments.create_shipment.additional_data.payment_type.name"
                        )}
                    </span>
                    <select
                        className={`${style.select} col-span-10`}
                        id="sender-city"
                        value={state["payment-type"]}
                        onChange={setPaymentType}
                    >
                        {paymentTypes.map((option, index) => (
                            <option
                                key={index}
                                defaultValue={
                                    state["payment-type"] === option.value
                                }
                                value={option.value}
                            >
                                {option.text[i18n.language]}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="grid grid-cols-12">
                    <span className="col-span-12 text-gray-600">
                        {t(
                            "shipments.create_shipment.additional_data.declared_price.name"
                        )}
                    </span>
                    <input
                        className={`${style.input} col-span-7 xs:col-span-8`}
                        id="declared-price"
                        value={state["declared-price"]}
                        onChange={setDeclaredPrice}
                    />
                    <select
                        className={`${style.select} col-span-3 xs:col-span-2`}
                        id="declared-price-currency"
                        value={state["declared-price-currency"]}
                        onChange={(e) => setDeclaredPriceCurrency(e)}
                    >
                        <option
                            defaultValue={
                                state["declared-price-currency"] === "TRY"
                            }
                            value={"TRY"}
                        >
                            TL
                        </option>
                        <option
                            defaultValue={
                                state["declared-price-currency"] === "USD"
                            }
                            value={"USD"}
                        >
                            USD
                        </option>
                        <option
                            defaultValue={
                                state["declared-price-currency"] === "EUR"
                            }
                            value={"EUR"}
                        >
                            EUR
                        </option>
                    </select>
                    <span className="col-span-12 text-emerald-600 text-xs">
                        {t(
                            "shipments.create_shipment.additional_data.declared_price.info"
                        )}
                    </span>
                </div>
                <div className="grid grid-cols-12">
                    <span className="col-span-12 text-gray-600">
                        {t(
                            "shipments.create_shipment.additional_data.sender_city.name"
                        )}
                    </span>
                    <select
                        className={`${style.select} col-span-10`}
                        id="sender-city"
                        value={state["sender-city-code"]}
                        onInput={setSenderCity}
                    >
                        {senderCities.map((option, index) => (
                            <option
                                selected={
                                    // if in state is selected city
                                    state["sender-city-code"] ===
                                        option.value ||
                                    //if in state is not selected city but in user has city
                                    (!state["sender-city-code"] ===
                                        option.value &&
                                        user &&
                                        user["sender-city-code"] ===
                                            option.value)
                                }
                                key={index}
                                value={option.value}
                            >
                                {option.text}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="grid grid-cols-12">
                    <SenderTownInput
                        senderCityCode={state["sender-city-code"]}
                        state={state["sender-town-id"]}
                        setState={setSenderTown}
                        enabled={true}
                    />
                </div>
                <div className="grid grid-cols-12">
                    <SenderDistrictComponent state={state} setState={setState}  />
                </div>

                <div className="grid grid-cols-12">
                    <span className="col-span-12 text-gray-600">
                        {t(
                            "shipments.create_shipment.additional_data.getting_package_type.name"
                        )}
                    </span>
                    <select
                        className={`${style.select} col-span-10`}
                        id="getting-package-type"
                        value={state["getting-package-type"]}
                        onChange={setDeliveryType}
                    >
                        <option
                            defaultValue={
                                state["getting-package-type"] === "visit office"
                            }
                            value={"visit office"}
                        >
                            {t(
                                "shipments.create_shipment.additional_data.getting_package_type.values.visit_office"
                            )}
                        </option>
                        <option
                            defaultValue={
                                state["getting-package-type"] === "local cargo"
                            }
                            value={"local cargo"}
                        >
                            {t(
                                "shipments.create_shipment.additional_data.getting_package_type.values.local_cargo"
                            )}
                        </option>
                        { selectedTownHasCourierDelivery &&
                            <option
                                defaultValue={
                                    state["getting-package-type"] === "courier"
                                }
                                value={"courier"}
                            >
                                {t(
                                    "shipments.create_shipment.additional_data.getting_package_type.values.courier"
                                )}
                            </option>
                        }
                    </select>
                </div>

                {state["getting-package-type"] === "courier" && (
                    <div className="grid grid-cols-12">
                        <span className="col-span-12 text-gray-600">
                            {t(
                                "shipments.create_shipment.additional_data.courier_speed.name"
                            )}
                        </span>
                        <select
                            className={`${style.select} col-span-10`}
                            id="sender-city"
                            value={state["delivery-speed"]}
                            onChange={setDeliverySpeed}
                        >
                            <option
                                defaultValue={
                                    state["delivery-speed"] ===
                                    deliverySpeeds.standard.value
                                }
                                value={deliverySpeeds.standard.value}
                            >
                                {t(
                                    "shipments.create_shipment.additional_data.courier_speed.values.standard"
                                )}
                            </option>
                            {selectedCityHasExpressPickup && (
                                <option
                                    defaultValue={
                                        state["delivery-speed"] ===
                                        deliverySpeeds.express.value
                                    }
                                    value={deliverySpeeds.express.value}
                                >
                                    {t(
                                        "shipments.create_shipment.additional_data.courier_speed.values.express"
                                    )}
                                </option>
                            )}
                        </select>
                    </div>
                )}

                {state["getting-package-type"] === "courier" && (
                    <div className="grid grid-cols-12">
                        <span className="col-span-12 text-gray-600">
                            {t(
                                "shipments.create_shipment.additional_data.sender_address.name"
                            )}
                        </span>

                        <input
                            className={`${style.input} ${style.standard} col-span-12 xs:col-span-10`}
                            id="sender-address"
                            value={state["sender-address"]}
                            onChange={setSenderAddress}
                        />
                    </div>
                )}

                {isB2BPackage(state["package-type"]) && (
                    <>
                        <div className="grid grid-cols-12">
                            <span className="col-span-12 text-gray-600">
                                {t(
                                    "shipments.create_shipment.additional_data.B2B_order_type.name"
                                )}
                            </span>
                            <select
                                className={`${style.select} col-span-10`}
                                id="B2B-order-type"
                                value={state["B2B-order-type"]}
                                onInput={setB2BOrderType}
                            >
                                <option
                                    selected={
                                        state["B2B-order-type"] === "courier"
                                    }
                                    value={"courier"}
                                >
                                    {"Courier"}
                                </option>
                                <option
                                    selected={
                                        state["B2B-order-type"] === "ETGB"
                                    }
                                    value={"ETGB"}
                                >
                                    {"ETGB"}
                                </option>
                            </select>
                        </div>
                        <div className="grid grid-cols-12">
                            <span className="col-span-12 text-gray-600">
                                {t(
                                    "shipments.create_shipment.additional_data.B2B_order_number.name"
                                )}
                                ({t("global.optional")})
                            </span>
                            <input
                                className={`${style.input} ${style.standard} col-span-10`}
                                id="b2b-order-number"
                                value={state["B2B-order-number"]}
                                onChange={setB2BOrderNumber}
                                placeholder={t(
                                    "shipments.create_shipment.additional_data.B2B_order_number.placeholder"
                                )}
                            />
                        </div>
                    </>
                )}
            </main>
        </>
    );
};

export default AdditionalData;
